import React, { useState } from "react";
import { Modal, Button, Icon } from "semantic-ui-react";
import InventoryCard from "./InventoryCard"; // Adjust import path as needed
import axios from "../../../../../../../apis/dvdlocator";

const InventoryBulkEdit = ({ inventory: initialInventory, open, onClose }) => {
  const [inventory, setInventory] = useState(initialInventory);

  const handlePartNumberEdit = async (inventoryId, newPartNumber) => {
    await axios.put(`/inventory/${inventoryId}`, { partNumber: newPartNumber });

    setInventory((prevInventory) =>
      prevInventory.map((item) =>
        item.inventory_id === inventoryId
          ? { ...item, part_number: newPartNumber }
          : item
      )
    );
  };

  return (
    <Modal open={open} onClose={onClose} size="large">
      <Modal.Header>
        <Icon name="edit" />
        Inventory Bulk Edit
      </Modal.Header>
      <Modal.Content scrolling>
        {inventory.map((item) => (
          <InventoryCard
            key={item.inventory_id}
            inventory={item}
            onPartNumberEdit={handlePartNumberEdit}
          />
        ))}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} primary>
          <Icon name="checkmark" />
          Done
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default InventoryBulkEdit;
